import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Container, Row, Col, Card, Table, Button } from 'react-bootstrap';
import Footer from '../layout/Footer';
import FormModal from '../../Utils/FormModal';
import { postToAPI, getFromAPI, deleteFromAPI, showAlert, putToAPI } from '../../Utils/utils';
import { toast } from 'react-toastify';
import Icon from '@mdi/react';
import { mdiPlus } from '@mdi/js';
import JSZip from 'jszip';
import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import $ from 'jquery';
import DataTable from 'datatables.net-dt';

export default function Locker() {
  const tableRef = useRef(null);
  const [lockerData, setLockerData] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [formModalShow, setFormModalShow] = useState(false);
  const [editedTeamID, setEditedTeamID] = useState('');
  const [data, setData] = useState(() => ({
    lkrTitle: '',
    lkrLink: '',
    lkrUserId: '',
    lkrPassword: '',
    lkrDes: '',
    lkrTag: [],
    lkrStaff: [],
    created_user_id: localStorage.getItem("loggedInStaffId"),
    last_modified_user_id: localStorage.getItem("loggedInStaffId"),
  }));

  const loggedInStaffId = localStorage.getItem("loggedInStaffId");

  // Fetch data handlers
  const fetchStaffData = useCallback(async () => {
    try {
      const response = await getFromAPI('FtsStaff/');
      const staffOptions = response.map(staff => ({
        value: staff.staffid,
        label: staff.firstname,
      }));
      setStaffData(staffOptions);
      
      const userName = localStorage.getItem('firstname');
      if (userName) {
        const loggedInUser = staffOptions.find(staff => staff.label === userName);
        if (loggedInUser) {
          setData(prev => ({
            ...prev,
            lkrStaff: [loggedInUser]
          }));
        }
      }
    } catch (error) {
      console.error('Error fetching staff data:', error);
    }
  }, []);

  const fetchLockerData = useCallback(async () => {
    try {
      const response = await getFromAPI(`get_lockers/?staffId=${loggedInStaffId}`);
      setLockerData(response); // No filtering needed here
    } catch (error) {
      console.error('Error fetching locker data:', error);
      setLockerData([]);
    }
  }, [loggedInStaffId]);

  // Initial data fetch
  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([fetchStaffData(), fetchLockerData()]);
      } catch (error) {
        console.error('Error fetching initial data:', error);
      }
    };
    fetchData();
  }, [fetchStaffData, fetchLockerData]);

  // DataTable initialization
  useEffect(() => {
    let table;
    if (lockerData.length && tableRef.current) {
      DataTable.Buttons.jszip(JSZip);
      pdfMake.vfs = pdfFonts.pdfMake.vfs;

      table = $(tableRef.current).DataTable({
        dom: "Bflrtip",
        pageLength: 25,
        buttons: [{
          extend: 'excel',
          className: 'btn btn-outline-secondary',
          text: '<svg viewBox="0 0 24 24" class="btn-icon me-1"><path d="M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M12.9 14.5L15.8 19H14L12 15.6L10 19H8.2L11.1 14.5L8.2 10H10L12 13.4L14 10H15.8L12.9 14.5Z"></path></svg> Export to Excel',
          filename: 'myRetails_Locker',
          title: 'myRetails Locker'
        }],
        data: lockerData.map((item, i) => [
          i + 1,
          item.title,
          `<a href="${item.link}" target="_blank" rel="noopener noreferrer">${item.link}</a>`,
          item.tags.split(',').map(tag => `<span class="badge bg-soft-success">${tag.trim()}</span>`).join(' '),
          item.description,
          `<span class="password-cell" title="${item.password}">${'*'.repeat(item.password.length)}</span>`,
          item.id
        ]),
        columns: [
          { title: "Sr.No" },
          { title: "Title" },
          { title: "Link" },
          { title: "Tag", className: 'table-data-width' },
          { title: "Description", className: 'table-data-width' },
          { title: "Password", className: 'table-ps-clm' },
          {
            title: "Action",
            className: 'py-2',
            render: (_, __, row) => `
              <div class="d-flex gap-2">
                <button class="btn btn-soft-info p-0 table-btn lkr-edit" data-id="${row[6]}">
                  <div class="avatar avatar-xs"><svg viewBox="0 0 24 24" class="avatar-icon"><path d="M5,3C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19H5V5H12V3H5M17.78,4C17.61,4 17.43,4.07 17.3,4.2L16.08,5.41L18.58,7.91L19.8,6.7C20.06,6.44 20.06,6 19.8,5.75L18.25,4.2C18.12,4.07 17.95,4 17.78,4M15.37,6.12L8,13.5V16H10.5L17.87,8.62L15.37,6.12Z" style="fill: currentcolor;"></path></svg></div>
                </button>
                <button class="btn btn-soft-danger p-0 table-btn lkr-delete" data-id="${row[6]}">
                  <div class="avatar avatar-xs"><svg viewBox="0 0 24 24" class="avatar-icon"><path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" style="fill: currentcolor;"></path></svg></div>
                </button>
              </div>`
          },
        ],
        autoWidth: false,
        language: {
          search: '',
          searchPlaceholder: "Search...",
          paginate: { previous: '«', next: '»' }
        },
        destroy: true
      });

      const wrapper = document.getElementById("mainDatatableLocker_wrapper");
      wrapper?.classList.toggle("dtl-right", document.getElementsByClassName("dt-buttons").length > 0);
    }

    return () => {
      if (table) table.destroy();
    };
  }, [lockerData]);

  // Event handlers
  const handleInputChange = useCallback((index, field, value) => {
    setData(prev => ({
      ...prev,
      [field]: value
    }));
  }, []);

  const handleLockerModal = useCallback(() => {
    const loggedInUser = staffData.find(staff => staff.value === parseInt(loggedInStaffId, 10));
    setData(prev => ({
      ...prev,
      lkrStaff: loggedInUser ? [loggedInUser] : [],
      created_user_id: loggedInStaffId,
      last_modified_user_id: loggedInStaffId
    }));
    setEditedTeamID('');
    setFormModalShow(true);
  }, [staffData, loggedInStaffId]);

  const handleFormModalClose = useCallback(() => {
    setFormModalShow(false);
    setData({
      lkrTitle: '',
      lkrLink: '',
      lkrUserId: '',
      lkrPassword: '',
      lkrDes: '',
      lkrTag: [],
      lkrStaff: [],
      created_user_id: loggedInStaffId,
      last_modified_user_id: loggedInStaffId
    });
    setEditedTeamID('');
  }, [loggedInStaffId]);

  const handleDeleteLocker = useCallback((id) => {
    showAlert('Are you sure you want to delete this Locker?', 'confirm', async (result) => {
      if (result) {
        try {
          const response = await deleteFromAPI(`FtsLocker/${id}/`);
          if (response.status) {
            toast.success('Locker deleted successfully!');
            fetchLockerData();
          } else {
            toast.error('Error deleting Locker');
          }
        } catch (error) {
          console.error('Error deleting Locker:', error);
          toast.error('Error deleting Locker');
        }
      }
    });
  }, [fetchLockerData]);

  const handleSubmit = useCallback(async () => {
    const staffList = ensureLoggedInUser(data.lkrStaff);
    const lockerData = prepareLockerData(data, staffList);
    
    try {
      const response = await postToAPI("FtsLocker/", lockerData);
      if (response) {
        toast.success('Locker Added successfully!');
        fetchLockerData();
        handleFormModalClose();
      }
    } catch (error) {
      console.error("Error adding locker:", error);
      toast.error('Error adding locker');
    }
  }, [data, fetchLockerData, handleFormModalClose]);

  const handleEditClick = useCallback((id) => {
    const locker = lockerData.find(item => String(item.id) === String(id));
    if (!locker) return;

    const staffIds = (locker.Staffname || '').split(',').filter(Boolean).map(id => parseInt(id, 10));
    if (loggedInStaffId && !staffIds.includes(parseInt(loggedInStaffId, 10))) {
      staffIds.push(parseInt(loggedInStaffId, 10));
    }

    const preselectedEmployees = staffIds
      .map(id => staffData.find(emp => emp.value === id))
      .filter(Boolean);

    setData({
      lkrTitle: locker.title,
      lkrLink: locker.link,
      lkrUserId: locker.uid,
      lkrPassword: locker.password,
      lkrTag: (locker.tags || '').split(','),
      lkrStaff: preselectedEmployees,
      lkrDes: locker.description,
      created_user_id: loggedInStaffId,
      last_modified_user_id: loggedInStaffId
    });
    setEditedTeamID(id);
    setFormModalShow(true);
  }, [lockerData, staffData, loggedInStaffId]);

  const updateDataInDatabase = useCallback(async (itemDetails) => {
    const staffList = ensureLoggedInUser(itemDetails.lkrStaff);
    const requestBody = prepareLockerData(itemDetails, staffList);

    try {
      const response = await putToAPI(`FtsLocker/${editedTeamID}/`, requestBody);
      if (response) {
        toast.success('Locker updated successfully!');
        fetchLockerData();
        handleFormModalClose();
      }
    } catch (error) {
      console.error('Error updating Locker:', error);
      toast.error('Error updating Locker');
    }
  }, [editedTeamID, fetchLockerData, handleFormModalClose]);

  // Helper functions
  const ensureLoggedInUser = (staffList) => {
    const currentStaff = [...staffList];
    const loggedInUser = staffData.find(staff => staff.value === parseInt(loggedInStaffId, 10));
    if (loggedInUser && !currentStaff.some(staff => staff.value === loggedInUser.value)) {
      currentStaff.push(loggedInUser);
    }
    return currentStaff;
  };

  const prepareLockerData = (formData, staffList) => ({
    title: formData.lkrTitle,
    link: formData.lkrLink,
    uid: formData.lkrUserId,
    password: formData.lkrPassword,
    description: formData.lkrDes,
    tags: Array.isArray(formData.lkrTag) ? formData.lkrTag.join(',') : '',
    Staffname: staffList.map(staff => staff.value).join(','),
    created_user_id: loggedInStaffId,
    last_modified_user_id: loggedInStaffId
  });

  const validateForm = () => {
    const urlRegex = /^(https?:\/\/)?([\w\-]+(\.[\w\-]+)+)(:[0-9]+)?(\/.*)?$/;
    return {
      isValid: data.lkrTitle.trim() &&
        data.lkrLink.trim() && urlRegex.test(data.lkrLink.trim()) &&
        data.lkrUserId.trim() &&
        data.lkrPassword.trim() &&
        data.lkrTag.length > 0 &&
        data.lkrStaff.length > 0&&
        data.lkrDes.trim(),
        error: !data.lkrTitle.trim() ? '. add a proper title' :
        !data.lkrLink.trim() ? 'Please add a proper link' :
        !urlRegex.test(data.lkrLink.trim()) ? 'Please enter a valid link' :
        !data.lkrUserId.trim() ? 'Please add a proper UID' :
        !data.lkrPassword.trim() ? 'Please add a proper password' :
        data.lkrTag.length === 0 ? 'Please add at least one tag' :
        data.lkrStaff.length === 0 ? 'Please add at least one staff' : ''
    };
  };

  const handleBothActions = useCallback(() => {
    const { isValid, error } = validateForm();
    if (!isValid) {
      toast.error(error);
      return;
    }

    if (editedTeamID === '') {
      const isDuplicate = lockerData.some(locker => locker.title === data.lkrTitle);
      if (isDuplicate) {
        toast.error('Locker name already exists');
        return;
      }
      handleSubmit();
    } else {
      updateDataInDatabase(data);
    }
  }, [data, editedTeamID, lockerData, handleSubmit, updateDataInDatabase]);

  // Table event listeners
  useEffect(() => {
    const handleTableClick = (e) => {
      const target = e.target.closest('.lkr-edit, .lkr-delete');
      if (!target) return;
      
      const id = target.getAttribute('data-id');
      if (target.classList.contains('lkr-edit')) {
        handleEditClick(id);
      } else if (target.classList.contains('lkr-delete')) {
        handleDeleteLocker(id);
      }
    };

    const tbody = tableRef.current?.querySelector('tbody');
    tbody?.addEventListener('click', handleTableClick);
    return () => tbody?.removeEventListener('click', handleTableClick);
  }, [handleEditClick, handleDeleteLocker]);

  // Form configuration
  const rows = [{
    columns: [
      { size: { lg: 12 }, label: <span>Title <span style={{ color: 'red' }}>*</span></span>, type: 'text', name: 'lkrTitle', placeholder: 'Enter title...', value: data.lkrTitle },
      { size: { lg: 12 }, label: <span>Link <span style={{ color: 'red' }}>*</span></span>, type: 'text', name: 'lkrLink', placeholder: 'Enter link...', value: data.lkrLink },
      { size: { lg: 6 }, label: <span>User ID <span style={{ color: 'red' }}>*</span></span>, type: 'text', name: 'lkrUserId', placeholder: 'Enter user id...', value: data.lkrUserId },
      { size: { lg: 6 }, label: <span>Password <span style={{ color: 'red' }}>*</span></span>, type: 'password', name: 'lkrPassword', placeholder: 'Enter Password...', value: data.lkrPassword },
      { size: { md: 12 }, label: <span>Description <span style={{ color: 'red' }}>*</span></span>, type: 'textarea', name: 'lkrDes', formrow: '3', placeholder: 'Enter description...', value: data.lkrDes },
      { size: { md: 12 }, label: <span>Tags <span style={{ color: 'red' }}>*</span></span>, type: 'tagInputs', name: 'lkrTag', placeholder: 'Enter tags and Press Enter...', value: data.lkrTag },
      { size: { md: 12 }, label: <span>Assign to Staff<span style={{ color: 'red' }}>*</span></span>, type: 'multiSelect', name: 'lkrStaff', value: data.lkrStaff, placeholder: 'Select Staff', options: staffData, getOptionLabel: option => option.label, getOptionValue: option => option.value }
    ]
  }];

  const buttons = [
    { variant: "primary", text: "Ok", onClick: handleBothActions, disabled: !validateForm().isValid },
    { variant: "secondary", text: "Cancel", onClick: handleFormModalClose }
  ];

  return (
    <div className="page-wrapper">
      <div className='page-content'>
        <Container>
          <Row>
            <Col md={12}>
              <Card>
                <Card.Body>
                  <div className='d-flex align-items-center justify-content-between mb-4'>
                    <Card.Title className='mb-0'>Locker</Card.Title>
                    <Button variant="light mb-sm-0 mb-3" onClick={handleLockerModal}>
                      <Icon path={mdiPlus} className="btn-icon me-1" /> Add Locker
                    </Button>
                  </div>
                  <Table responsive bordered className='table-nowrap' id='mainDatatableLocker' ref={tableRef}>
                    <thead className='table-light'></thead>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
      <FormModal 
        backdrop="static" 
        keyboard={false} 
        title={editedTeamID ? "Edit Locker" : "Add Locker"} 
        modalSize="lg" 
        formModalShow={formModalShow} 
        Buttons={buttons} 
        handleFormModalClose={handleFormModalClose} 
        rows={rows} 
        handleInputChange={handleInputChange} 
      />
    </div>
  );
}